module.exports = __webpack_public_path__ + "img/nav-right-with-contact-white-kia.e470d573.png";